import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import * as XLSX from 'xlsx';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { PopoverController } from '@ionic/angular';
import { OpcionesExportarComponent } from 'src/app/componentes/opciones-exportar/opciones-exportar.component';


@Component({
  selector: 'app-anticipos',
  templateUrl: './anticipos.component.html',
  styleUrls: ['./anticipos.component.scss'],
})
export class AnticiposComponent implements OnInit {

  @Input() Datos = []
  @Input() DatosAplicados = []
  Copia = ""
  aplic: boolean = false;
  filtrando = false

  disabled: boolean=true;

  @Output() recargar = new EventEmitter();
  @Output() correo = new EventEmitter();

  filtroTipo = ""

  constructor(private conexion: ConexionService, private utilidades: UtilidadesService,
    private popoverController: PopoverController) { }

  Fecha = { Fecha1: "", Fecha2: "" }

  @Input() UserID = ""
  HijosSelect = []
  HijosSeleccionados = []
  @Input() Hijos = []
  @ViewChild('pdfTable') pdfTable: ElementRef;
  pdf: string = ""
  todo = false;

  @Output() desabilitar = new EventEmitter();

  ngOnInit() {

    this.HijosSelect = []
    // for (let i of this.Hijos) {
    //   this.HijosSelect.push({ Nombre: i.Nombre1 + " " + i.Apellido1, Foto: i.Url, Value: i.Id })
    // }
    setTimeout(() => {
      this.getAnticipos()
      setTimeout(() => {
        this.getAnticiposAplicados()
      }, 200);
      this.todo = true
    }, 10);
  }



  getAnticipos() {
    this.utilidades.Loading("Cargando documentos")
    this.conexion.getAnticipos(this.UserID,
      this.Fecha.Fecha1, this.Fecha.Fecha2).subscribe((resp) => {
        this.desabilitar.emit(false)
        this.disabled=false;
        this.utilidades.CerrarLoading()
        this.utilidades.Depuracion(resp, "console", "")
        if (resp.Respuesta == "Exito") {
          this.Datos = resp.Datos
          this.utilidades.Depuracion(resp.Datos, "console", "")
        }
      }, (err) => {
        this.utilidades.CerrarLoading()
        this.utilidades.Alerta("En estos momentos este servicio no se encuentra disponible. Por favor, inténtelo más tarde.")
        this.desabilitar.emit(true)
        this.disabled=true;
        this.utilidades.ValidarUser(err)
      })
  }


  async Exportar(e: Event) {
    const popover = await this.popoverController.create({
      component: OpcionesExportarComponent,
      event: e,
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();

    this.utilidades.Depuracion(data, "console", "")
    if (data == "pdf") {
      this.pdfF()
    } else if (data == "excel") {
      this.exportexcel()
    }
  }

  getAnticiposAplicados() {
    // this.utilidades.Loading("Cargando documentos")
    this.conexion.getAnticipos(this.UserID,
      this.Fecha.Fecha1, this.Fecha.Fecha2, "1").subscribe((resp) => {
        // this.utilidades.CerrarLoading()
        this.utilidades.Depuracion(resp, "console", "")
        if (resp.Respuesta == "Exito") {
          this.DatosAplicados = resp.Datos
          this.utilidades.Depuracion(resp.Datos, "console", "")
        }
      }, (err) => {
        // this.utilidades.CerrarLoading()
        this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

        this.utilidades.ValidarUser(err)
      })
  }


  Sumar(arreglo, columna) {
    let total = 0;
    for (let i of arreglo) {
      total += Number(i[columna])
    }

    return total;
  }

  pdfF() {
    
    this.utilidades.Toast("Descargando PDF...", 3000, "download-outline")
    let d = document.getElementById("imprimible")
    d.innerHTML = this.TextoMostrablePDF()
    this.pdf = "pedefeable"
    document.getElementById("cc").scrollTo({ top: 0, behavior: "smooth" })
    setTimeout(() => {
      let pd = new jspdf('p', 'pt', 'a4')
      pd.html(this.pdfTable.nativeElement, {
        "margin": [25, 0, 25, 0], "autoPaging":"text",
        callback: (pdf) => {
          pdf.save("Anticipos " + String(new Date()) + ".pdf")
          setTimeout(() => {
            d.innerHTML = ""
            this.pdf = ""
          }, 800);
        }
      })
    }, 100);

  }

  FiltroPorTipo() {
    setTimeout(() => {

      if (this.Copia != "") {
        if (!this.aplic) {
          this.Datos = JSON.parse(this.Copia)
          this.Copia = ""
        } else {
          this.DatosAplicados = JSON.parse(this.Copia)
          this.Copia = ""
        }
      }

      if (this.filtroTipo != "") {
        this.filtrando = true
        if (!this.aplic) {
          this.Copia = JSON.stringify(this.Datos)
          let x = this.Datos.filter(dato => dato.Tipo == this.filtroTipo)
          this.Datos = x
        } else {
          this.Copia = JSON.stringify(this.DatosAplicados)
          let x = this.DatosAplicados.filter(dato => dato.Tipo == this.filtroTipo)
          this.DatosAplicados = x
        }
      } else {
        if (this.filtrando) {
          this.filtrando = false
          if (!this.aplic) {
            this.Datos = JSON.parse(this.Copia)
            this.Copia = ""
          } else {
            this.DatosAplicados = JSON.parse(this.Copia)
            this.Copia = ""
          }
        }
      }
    }, 100);
  }

  Totales(arreglo, key) {
    let total = 0;
    for (let i of arreglo) {
      total += this.Sumar(i.Documentos, key)
    }

    return total
  }


  exp = "TablaExportar"
  excel = false
  exportexcel(): void {
    this.exp = ""
    this.excel = true;
    this.utilidades.Toast("Descargando Excel...", 3000, "download-outline")
    setTimeout(() => {
      // /* table id is passed over here */
      // let element = document.getElementById('datos');
      // const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      // /* generate workbook and add the worksheet */
      // const wb: XLSX.WorkBook = XLSX.utils.book_new();
      // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // /* save to file */
      // XLSX.writeFile(wb, "Anticipos " + String(new Date()) + ".xlsx");

      const downloadLink = document.createElement("a");
      const dataType = 'application/vnd.ms-excel';
      const table = document.getElementById("datos");
      const tableHtml = table.outerText.replace(/ /g, '%20')
      document.body.appendChild(downloadLink);
      downloadLink.href = 'data:' + dataType + ' ' + tableHtml;
      downloadLink.download = "Anticipos " + String(new Date()) + ".xls";
      downloadLink.click();

      this.exp = "TablaExportar"
      this.excel = false

    }, 150);
  }

  TextoMostrable() {
    let titulo = ""
    if (!this.aplic) {
      titulo = "Reporte de Anticipos"
    } else {
      titulo = "Reporte de Anticipos con Aplicación"
    }
    return '<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title>Documentos pendientes</title> <style> *{font-family: "Arial", sans-serif !important; letter-spacing: 0.1px;} .h3{margin: 1px 2px 2px 2px; font-size: 14px; font-weight: 800;}  table{ border-collapse:separate; width: 100%; table-layout: fixed;} th { padding: 5px 10px; }  .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; font-size: 11px;} .table_header th:last-child{ border-right: 1px solid black; border-top-right-radius: 5px !important; border-bottom-right-radius: 5px !important; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 5px !important; border-bottom-left-radius: 5px !important; }  td{ text-align: left; font-size: 11px;} .thImp{padding: 7px 10px; font-size: 11px; text-align: center; width: 100px;}  .desaparecibles { display: none; }  .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; } .table_header th:last-child { border-right: 1px solid black; border-top-right-radius: 10px; border-bottom-right-radius: 10px; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 10px; border-bottom-left-radius: 10px; } .tipoAnt { font-size: 11px; text-align: center; font-weight: 500; text-transform: uppercase; background-color: #d3d3d3;} .tdTotales { text-align: right; border-top: 1px solid #000000; padding-top: 2px; } .tdAplic{padding: 5px 5px 5px 25px; font-size: 11px;}  .tdAplicM{text-align: right; padding: 5px 0 5px 25px; font-size: 11px;} </style> </head> <body> <div style="text-align: center; font-family: "Arial", sans-serif !important; "> <h3 class="h3"><b>INSTITUTO DE DESARROLLO INTEGRAL LEONARDO DA VINCI </b></h3> <p style="font-size: 11px; margin: 3px 1px;"> "SEA NUESTRO AVAL EL RECTO PENSAR" </p> <p style="font-size: 15px; margin: 10px 0 1px 0;"> ' + titulo + ' </p>  <p style="font-size: 10px; margin: 5px 1px;"> <b>Desde:</b>  {{FechaDesde}} <b style="margin-left: 5px;">Hasta:</b> {{FechaHasta}}  </p> </div> <br> {{Hola}} </body> </html>'.
      replace("{{Hola}}", document.getElementById("todo").innerHTML)
  }

  TextoMostrablePDF() {
    let titulo = ""
    if (!this.aplic) {
      titulo = "Reporte de Anticipos"
    } else {
      titulo = "Reporte de Anticipos con Aplicación"
    }
    return '<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title>Documentos pendientes</title> <style> *{font-family: "Arial", sans-serif !important; letter-spacing: 0.1px;} .h3{margin: 1px 2px 2px 2px; font-size: 11px; font-weight: bold;}  table{ border-collapse:separate; width: 100%; table-layout: fixed;} th { padding: 5px 10px; }  .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; font-size: 9px !important;} .table_header th:last-child{ border-right: 1px solid black; border-top-right-radius: 5px !important; border-bottom-right-radius: 5px !important; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 5px !important; border-bottom-left-radius: 5px !important; }  td{ text-align: left; font-size: 9px !important;} .thImp{padding: 7px 10px; font-size: 9px !important; text-align: center; width: 80px !important;}  .desaparecibles { display: none; }  .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; } .table_header th:last-child { border-right: 1px solid black; border-top-right-radius: 10px; border-bottom-right-radius: 10px; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 10px; border-bottom-left-radius: 10px; } .tipoAnt { font-size: 9px !important; text-align: center; font-weight: 500; text-transform: uppercase; background-color: #d3d3d3;}  .tdAplic{padding: 5px 5px 5px 25px; font-size: 8px !important;}  .tdAplicM{text-align: right; padding: 5px 0 5px 25px; font-size: 8px !important;} .tdTotales { text-align: right; border-top: 1px solid #000000; padding-top: 2px; } </style> </head> <body> <div style="text-align: center; font-family: "Arial", sans-serif !important; "> <h3 class="h3"><b>INSTITUTO DE DESARROLLO INTEGRAL LEONARDO DA VINCI </b></h3> <p style="font-size: 9px !important; margin: 3px 1px;"> "SEA NUESTRO AVAL EL RECTO PENSAR" </p> <p style="font-size: 12px; margin: 10px 0 1px 0;"> ' + titulo + ' </p>  <p style="font-size: 8px; margin: 5px 1px;"> <b>Desde:</b>  {{FechaDesde}} <b style="margin-left: 5px;">Hasta:</b> {{FechaHasta}}  </p> </div> <br> {{Hola}} </body> </html>'.
      replace("{{Hola}}", document.getElementById("todo").innerHTML)
  }

  Imprimir() {

    let vent = window.open('', '', 'height=800, width=800');
    vent.document.write(this.TextoMostrable())
    vent.document.close()
    setTimeout(() => {
      vent.print()
    }, 300);

  }


  HayDatos(): boolean {
    if (document.getElementById("datos")) {
      if (document.getElementById("datos").innerText.length > 130) {
        return true;
      }
    }
    return false;
  }
}
